<template>
  <v-container>
      <!-- <div :text="microdesc">{{microdesc}}</div> -->
      <div  v-html="microdesc"></div>

  </v-container>
</template>

<script>
export default {
    data() {
        return {
            microdesc : ''
        }
    },
    created() {
        this.readMicro();
    },
    methods: {
        readMicro(){
            this.$store
            .dispatch(
            "GetFromAPI",
            "/admin/micro/" + this.$route.params.key
            )
            .then((response) => {
                console.log(response)
                this.microdesc = response.data.data.microdesc
            });
        }
    },
}
</script>
<style >
    .ql-align-center{
        text-align: center;
    }
    .ql-align-right{
         text-align: right  !important
    }
</style>